// extracted by mini-css-extract-plugin
module.exports = {"breakpointPhone":"768px","breakpointAvgDesk":"1240px","breakpointMobile":"1024px","mediaAvgDesktop":"\"(min-width: 1240px)\""};